// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/advicebar.scss
// module id = 332
// module chunks = 2